import { render, staticRenderFns } from "./add-equ.vue?vue&type=template&id=8dac0dc0&scoped=true&"
import script from "./add-equ.vue?vue&type=script&lang=js&"
export * from "./add-equ.vue?vue&type=script&lang=js&"
import style0 from "./add-equ.vue?vue&type=style&index=0&id=8dac0dc0&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dac0dc0",
  null
  
)

export default component.exports